import { NSARouterMakerResult } from "namirasoft-account-react";
import { AgentRow } from "namirasoft-expert";
import { NSCard, NSLoading, NSNoData, NSRow, NSTitle } from "namirasoft-site-react";
import { Component } from "react";
import { ExpertLayout } from "../ExpertLayout";
import { ExpertRouterProps } from "../ExpertRouterProps";
import { ExpertRoutes } from "../ExpertRoutes";

interface AgentSelectPageProps extends NSARouterMakerResult, ExpertRouterProps { }

interface AgentSelectPageState
{
    agents: AgentRow[];
    loading: boolean;
}

class AgentSelectPage extends Component<AgentSelectPageProps, AgentSelectPageState>
{
    constructor(props: AgentSelectPageProps)
    {
        super(props);
        this.state = {
            agents: [],
            loading: true,
        };
    }

    override componentDidMount(): void
    {
        this.loadAgents();
    }

    private async loadAgents()
    {
        try
        {
            let response = await this.props.servers.expert.agent.List(null, 1, 100, [], null);
            this.setState({ agents: response.rows, loading: false });
        }
        catch
        {
            this.setState({ loading: false });
        }
    }

    override render()
    {
        return (
            <ExpertLayout
                {...this.props}
            >
                <>
                    {
                        this.state.loading &&
                        <NSLoading />
                    }
                    <NSTitle title="Select an Agent" classList={["mb-4"]} style={{ fontSize: "1.5rem" }} />
                    <NSRow>
                        {
                            this.state.agents.map((agent) => (
                                <NSCard
                                    key={agent.id}
                                    title={agent.name}
                                    description={agent.description ?? undefined}
                                    image={{ src: "https://static.namirasoft.com/image/namirasoft/expert/logo/base.png", alt: "Agent" }}
                                    link={{ href: ExpertRoutes.Chat_AgentNew(agent.id), target: "_self" }}
                                />
                            ))
                        }
                    </NSRow>
                    {
                        !this.state.loading && this.state.agents.length < 1 &&
                        <NSNoData lable="There is no agent." classList={["pb-4 rounded-4"]} />
                    }
                </>
            </ExpertLayout>
        );
    }
}

export default AgentSelectPage;